import React, { Component } from 'react';
import {MicroPipette} from '@learningblocks/storybook-components/lib/PhotosynthesisComponents/MicroPipette';


export class Graphics extends Component {

  constructor(props) {
    super(props);
  }

  getSolutionColour = (solutions) => {

    if(solutions !== null && typeof solutions !== 'undefined'){
      let pH = 0;
      // let volume = 0;

      for(var sol in solutions){
        //volume =+ solutions[sol].volume;
        pH =+ solutions[sol].pH;
      }

      pH = pH / Object.keys(solutions).length;

      let pHLookup = {
        "-1": 'red',
        "2": "rgb(246, 205, 15)",
        "6": "rgb(209, 185, 61)",
        "6.1": "rgb(212, 184, 41)",
        "6.3": "rgb(194, 184, 48)",
        "6.5": "rgb(154, 173, 58)",
        "6.7": "rgb(119, 145, 59)",
        "6.9": "rgb(85, 119, 54)",
        "7.1": "rgb(48, 89, 60)",
        "7.3": "rgb(1, 61, 70)",
        "7.5": "rgb(23, 35, 77)",
        "7.7": "rgb(26, 37, 83)",
        "7.9": "rgb(32, 39, 91)",
        "8.0": "rgb(3, 31, 92)",
        "12": "rgb(43, 45, 123)"
      }

      let match = Object.keys(pHLookup).reduce((a, b) => {
        return Math.abs(parseFloat(b) - parseFloat(pH)) < Math.abs(parseFloat(a) - parseFloat(pH)) ? b : a;
      })

      if(Object.keys(solutions).includes('BTB')){
        return pHLookup[match];
      } else {
        return "#66cef5"
      }
    }

  }

  render(){
    return(
    <MicroPipette
      type={this.props.type}
      hasTip={this.props.hasTip}
      solution={(this.props.solution)?this.getSolutionColour(this.props.solution):null}
      volume={this.props.volume}
      showVolumeModal={this.props.showVolumeModal}
      contactElement={this.props.contactElement}
      plungerTooltip={this.props.plungerTooltip}
      lang={this.props.lang}
      notebookExpanded={this.props.notebookExpanded}
      setVolume={
        (data) =>{
          this.props.setVol({ volume: data.volume, id: this.props.id })
        }
      }
      toggleShowVolumeModal={
        (data) =>{
          this.props.toggleShowVolumeModal({ data, id: this.props.id })
        }
      }
      removeTip={
        (data) =>{
          this.props.removeTip({ data, id: this.props.id })
        }
      }
      togglePlungerTooltip={
        (data) =>{
          this.props.togglePlungerTooltip({ data, id: this.props.id })
        }
      }
      onFirstStopper={
        (data) =>{
          this.props.onFirstStopper({ data, id: this.props.id })
        }
      }
      onSecondStopper={
        (data) =>{
          this.props.onSecondStopper({ data, id: this.props.id })
        }
      }
      onMix={
        (data) =>{
          this.props.onMix({ data, id: this.props.id })
        }
      }
    />
    );
  }
}
